import { EventEmitter, inject,Injectable } from '@angular/core';
import { Filter, Order, OrderType, Paginator, Search } from '@docpath/linces-angular-components/common';
import { Table, TableField, TableFieldIcon, TableFieldIcons, TableFieldLink, TableFieldText, TableRow } from '@docpath/webcomponents';
import { faComment, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { FailedJobsResult } from '../../models/failed-jobs-result';
import { Notification } from '../../models/notification';
import { NotificationOptions } from '../../models/notification-options';
import { FailedJobsFormService } from '../../services/failed-jobs-form.service';
import { FailedJobsHttpService } from '../../services/failed-jobs-http.service';

@Injectable({
    providedIn: 'root'
})
export class FailedJobsTableService {

    failedJobsLoaded: EventEmitter<FailedJobsResult> = new EventEmitter();
    private readonly i18nPrefix = 'failed-jobs';
    private currentPage: number;
    private elements: number;
    private currentSize: number;
    private notifications: Notification[] = [];

    private readonly failedJobsHttpService = inject(FailedJobsHttpService);
    private readonly failedJobsFormService = inject(FailedJobsFormService);
    private readonly cloudService = inject(CloudService);

    constructor() {
        this.currentPage = 1;
        this.elements = 0;
        this.currentSize = 25;
    }

    getCurrentPage(): number {
        return this.currentPage;
    }
    getElements(): number {
        return this.elements;
    }
    getNotifications(): Notification[] {
        return this.notifications;
    }
    getCurrentSize(): number {
        return this.currentSize;
    }

    getSelectedNotifications(table: Table): Notification[] {
        return table.body.filter(row => row.selected).map(row => row.content);
    }

    loadNotifications(filters: Filter[], page = this.currentPage, size = this.currentSize): void {
        this.currentPage = page;
        this.currentSize = size;

        const search = new Search(filters, [new Order('alias', OrderType.Asc)], [],
            new Paginator(page - 1, this.currentSize, this.elements));

        this.failedJobsHttpService.getNotifications(search, (result, totalSize) => {
            this.elements = totalSize;
            const failedJobsResult = result as unknown as FailedJobsResult;
            this.notifications = failedJobsResult.notifications as unknown as Notification[];
            this.failedJobsLoaded.emit(result);
        });
    }


    initTable(): Table {
        const header = this.initTableHeader();
        const body = this.initTableBody(new NotificationOptions([], [], []));

        return new Table(header, body);
    }

    initTableHeader(): TableRow {
        return new TableRow(
            [
                new TableFieldText(`${this.i18nPrefix}.table.alias`, undefined, undefined, undefined, '33%', true),
                new TableFieldText(`${this.i18nPrefix}.table.dge`, undefined, undefined, undefined, '33%', true),
                new TableFieldText(`${this.i18nPrefix}.table.alerts`, undefined, undefined, undefined, '34%', true)
            ]
        );
    }


    initTableBody(notificationOptions: NotificationOptions): TableRow[] {
        return notificationOptions.notifications.map(notification => {
            const fields: TableField[] = [],
                nameClickAction = () => this.failedJobsFormService.openEditNotificationForm(notification, notificationOptions);
            fields.push(new TableFieldLink(notification.alias, notification.alias, undefined, nameClickAction, notification.alias, '33%'));
            fields.push(new TableFieldText(notification.dge, undefined, undefined, notification.dge, '33%'));
            fields.push(this.getAlertsField(notification));
            const tableRow = new TableRow(fields);
            tableRow.content = notification;

            return tableRow;
        });
    }

    private getAlertsField(notification: Notification): TableFieldIcons {
        const alertsFieldData: Array<TableFieldIcon> = [];

        if (notification.sendEmail) {
            const smsIcon = new TableFieldIcon(faEnvelope, notification.email, undefined, undefined, undefined, { cssClass: 'ms-2 text-dpmedium' });
            alertsFieldData.push(smsIcon);
        }

        if (notification.sendSms && !this.cloudService.isModeCloud()) {
            const emailIcon2 = new TableFieldIcon(faComment, notification.phoneNumber, undefined, undefined, undefined, { cssClass: 'ms-2 text-dpmedium' });
            alertsFieldData.push(emailIcon2);
        }

        return new TableFieldIcons(alertsFieldData);
    }
}